import { DashboardHelper } from './../dashboard.service';
import { BaseDataStore } from './base-data.store';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApplicationModel } from '../../models/application.model';
import { ApplicationAPIService } from '../api/application.api.service';
import * as AppConstants from '../../modules/catch-core/data/constants/app.constants';
import { AlertService } from '../alert.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationStore extends BaseDataStore {
  private _applications: BehaviorSubject<ApplicationModel | null> = new BehaviorSubject<ApplicationModel | null>(null);
  public $applications: Observable<ApplicationModel | null> = this._applications.asObservable();

  get catchInternalApplicationNameList(): string[] {
    return [
      AppConstants.CATCH_INTERNAL_APP_JUSTTEST_LOWER,
      AppConstants.CATCH_INTERNAL_APP_SMARTBOARD_LOWER,
      AppConstants.CATCH_INTERNAL_APP_REPORT_LOWER,
      AppConstants.CATCH_INTERNAL_APP_SMARTMAP_LOWER,
    ];
  }

  get applications(): ApplicationModel | null {
    return this._applications.getValue();
  }

  set applications(applicationModel: ApplicationModel) {
    this._applications.next(applicationModel);
  }

  constructor(
    private applicationService: ApplicationAPIService,
    private dashboardHelper: DashboardHelper,
    private alertService: AlertService,
  ) {
    super();
    this.behaviorSubjectList.push(this._applications);
  }

  public loadInitialData(): void {
    if (this.subscribers.applicationSubscription) {
      this.subscribers.applicationSubscription.unsubscribe();
    }

    this.subscribers.applicationSubscription = this.applicationService.getApplications().subscribe({
      next: (res: any) => {
        const app = res as ApplicationModel; // Cast the response to ApplicationModel
        this._applications.next(app);
      },
      error: (err) => {
        // RxJS never fires `complete` after `error` - increment here too, otherwise a failed
        // request leaves dashboardHelper.initCount permanently short and the app-init loading
        // dialog never closes (see ui-state.store.ts's initCount >= 9 gate).
        console.log('Error retrieving ProductType >> ', err);
        this.alertService.showError('Error retrieving Applications!');
        this.dashboardHelper.initCount += 1;
      },
      complete: () => {
        this.dashboardHelper.initCount += 1;
      },
    });
  }
}
